// sets location based on a zip
// dont write HTML markup, write in php with the helper like
// $input = new \shoelace\business\PlzField($kunde, 'plz');
// then use
// $input->setId('xy');
// for defining your id
// on the location input use
// $input->setClass('xy');
// as target field
export class LocationByPlz {

    public getLocationByPlz() {

        const plzInputs = document.querySelectorAll<HTMLFormElement>('sl-input[data-get-location]');
        if (plzInputs.length < 1) {
            return;
        }
        plzInputs.forEach((plzInput) => {
            plzInput.addEventListener('sl-change', () => {
                if (plzInput.value === '') {
                    return;
                }

                const plz = plzInput.value.replace(/ /g, "");
                const locationInputId = plzInput.id;
                if (!plz || !locationInputId) {
                    return;
                }

                const locationInput = document.querySelector<HTMLFormElement>(`.${locationInputId}`);
                if (!locationInput) {
                    return;
                }

                const xhr = new XMLHttpRequest();

                xhr.open('GET', `/order/api_getort/${plz}`);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.send(plz);
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        locationInput.value = xhr.responseText;
                        locationInput.dispatchEvent(new Event('sl-change'));
                        return;
                    }
                };
            });
        });
    }
}

// Export fuer globales window object
if (typeof window !== 'undefined') {
    (window as any)['LocationByPlz'] = LocationByPlz;
}
